// PRD.276 — Elia AI Doctor Consult Integration.
//
// Chooses the real backend client when the Elia endpoint is configured, else
// falls back to the deterministic mock (tests / demo mode). Fail-closed: with
// no URL, Elia stays on the mock rather than pointing at nothing.

import type { EliaChatClient } from './elia-chat-types';
import { createMockEliaChatClient } from './mock-elia-chat-client';
import { createFirebaseEliaChatClient } from './firebase-elia-chat-client';

/** Pure selection — testable without import.meta. */
export function pickEliaChatClient(eliaUrl: string | undefined): EliaChatClient {
  const url = eliaUrl?.trim();
  if (url) return createFirebaseEliaChatClient(url);
  return createMockEliaChatClient();
}

export function resolveEliaChatClient(): EliaChatClient {
  return pickEliaChatClient(import.meta.env.VITE_ELIA_AI_URL);
}
